interface PanelSectionHeaderProps {
  children: React.ReactNode;
}

export function PanelSectionHeader({ children }: PanelSectionHeaderProps) {
  return <div className="flex items-center justify-between px-6">{children}</div>;
}
